import React from 'react';
import Header from '../components/ui/Header';
import { IntlProvider } from 'react-intl';
import { translations } from '../../../libs/i18n/translations';
import { defaultLocale } from '../../../libs/i18n/default';
import Footer from '../components/containers/Footer';
import Pages from '../pages'
import { useSelector } from 'react-redux'
import styles from '../../../shared/styles';
import Translate from '../../../shared/components/Translate'
// Polyfill packages
import 'array-flat-polyfill'

const Layout = ({ user, territory, children }) => {
  const locale = (window.I18n && window.I18n.locale) || defaultLocale
  const page = useSelector(state => state.page)
  const messages = translations[locale]
  const { layout, container } = styles(page, territory)

  return (
    <IntlProvider locale={locale} key={locale} messages={messages}>
      <div id='host_signup' style={layout}>
        { page != Pages.ADDRESS_PAGE && (
          <Header
            logoUrl={territory.logo_url}
            page={page}
            wizard_url={territory.wizard_help_url}
            firebaseEnabled={territory.enable_firebase_authentication}
          />
        )}
        <div className="container" style={container}>
          <div className="panel form-container">
            <div className="panel-body">
              {children}
            </div>
          </div>
        </div>
        { page != Pages.ADDRESS_PAGE && <Footer /> }
        <Translate />
      </div>
    </IntlProvider>
  );
}

export default Layout
